import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { ColumnsType } from 'antd/es/table';

import { AssetCategory, useAssets } from '@/entities/assets';
import { assetFieldSorter } from '@/entities/assets/helpers/assetFieldSorter';
import { Country } from '@/shared/components';
import { AssetDto, CollectionName, NAME_KEY_BY_ASSET_CATEGORY } from '@/shared/lib/sj-orm';

import { EntityTableOptions } from '../types';

export const useAssetsTableOptions = (): EntityTableOptions<AssetDto> => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'vfoImportDocument.columns' });
  const { getAssetsList } = useAssets();

  const assets = useMemo(() => getAssetsList(), []);

  const columns = useMemo<ColumnsType<AssetDto>>(
    () => [
      {
        key: 'title',
        title: t('title'),
        render: (item: AssetDto) =>
          item[NAME_KEY_BY_ASSET_CATEGORY[item.category] as keyof AssetDto] as string,
        sorter: assetFieldSorter.nickname,
      },
      {
        key: 'category',
        title: t('category'),
        width: 173,
        render: (item: AssetDto) => <AssetCategory category={item.category} />,
        sorter: assetFieldSorter.category,
      },
      {
        key: 'country',
        title: t('country'),
        width: 163,
        render: (item: AssetDto) => <Country code={item.country} />,
        sorter: assetFieldSorter.country,
      },
    ],
    [],
  );

  return {
    collectionName: CollectionName.ASSETS,
    data: assets,
    columns,
  };
};
